import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_121_add_parts_return: any[] = [
  {
      "componentType": "screenGroup",
      "title": "Parts return",
      "screenId": "121",
      "childComponents": [
          {
              "componentType": "form",
              "Name": "parts_return",
              "TableName": "service_spare_part_return",
              "Plugins": [
                  {
                      "type": "api"
                  }
              ],
              "columnNumber": "m1 t1 w1",
              "Fields": [
                  {
                      "componentType": "fieldGroup",
                      "Label": "Parts return details",
                      "BindValue": "con_parts_return_details",
                      "style": {
                          "direction": "column"
                      },
                      "childComponents": [
                          {
                              "componentType": "textField",
                              "name": "txt_return_no",
                              "label": "Return no#",
                              "placeholder": "This will be auto populate...",
                              "required": false,
                              "inputType": "text",
                              "Json_Attribute": "return_no",
                              "IsReadOnly": true,
                              "AutoPopulate": true,
                              "AutoPopulate_format": "PRN_[******]",
                              "BindValue": "txt_return_no"
                          },
                          {
                              "componentType": "dateField",
                              "name": "txt_returndate",
                              "label": "Return date",
                              "placeholder": "Return date",
                              "DefaultToday": true,
                              "required": true,
                              "Json_Attribute": "return_date",
                              "validation": [
                                  {
                                      "rule": "required",
                                      "message": "Return date is required"
                                  }
                              ],
                              "BindValue": "txt_returndate"
                          },
                          {
                              "componentType": "searchableDropdown",
                              "name": "issue_no",
                              "label": "Issue no",
                              "placeholder": "",
                              "required": true,
                              "lookupName": "issued_Spareparts",
                              "options": [],
                              "searchable": true,
                              "clearable": true,
                              "Json_Attribute": "issue_id",
                              "validation": [
                                  {
                                      "rule": "required",
                                      "message": "Issue no is required"
                                  }
                              ],
                              "BindValue": "issue_no"
                          }
                      ]
                  },
                  {
                      "componentType": "subModule",
                      "name": "sub_Checklist",
                      "label": "Part details",
                      "tableName": "service_spare_parts_return_details",
                      "lookupName": "issued_Spareparts_details",
                      "parentField": "issue_no",
                      "BindValue": "sub_checklist",
                      "childControls": [
                          {
                              "componentType": "selectDropdown",
                              "name": "drp_code",
                              "label": "Code",
                              "placeholder": "",
                              "required": false,
                              "lookupName": "issued_Spareparts_details",
                              "parentField": "issue_no",
                              "options": [],
                              "Json_Attribute": "codeid",
                              "BindValue": "drp_code"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_itemname",
                              "label": "Item name",
                              "placeholder": "",
                              "required": false,
                              "inputType": "text",
                              "Json_Attribute": "item_name",
                              "disabled": true,
                              "BindParent": {
                                  "drp_code": "item_name"
                              }
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_qty",
                              "label": "Qty",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "qty",
                              "BindValue": "txt_qty",
                              "disabled": true
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_return_qty",
                              "label": "Return qty",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "return_qty",
                              "BindValue": "txt_return_qty",
                              "validation": [
                                  {
                                      "rule": "pattern",
                                      "value": "^[0-9]*$",
                                      "message": "Only numbers are allowed"
                                  },
                                  {
                                      "rule": "condition",
                                      "condition": "[return_qty] <= [qty]",
                                      "message": "Return quantity cannot be greater than issued quantity"
                                  }
                              ]
                          },
                          {
                              "componentType": "batchAllocation",
                              "name": "return_batch_allocation",
                              "label": "Return Batch Allocation",
                              "metadataParentField": "product_id",
                              "metadataLookupName": "product_batch_by_product",
                              "issueQtyField": "txt_return_qty",
                              "rateField": "txt_rate",
                              "BindValue": "return_batch_allocation",
                              "Json_Attribute": "batch_allocation"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_rate",
                              "label": "Rate",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "rate",
                              "disabled": true
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_amount",
                              "label": "Amount",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "amount",
                              "disabled": true,
                              "ExpressionV2": "[txt_rate] * [txt_return_qty]"
                          }
                      ]
                  }
              ]
          },
          {
              "componentType": "button",
              "name": "Submit",
              "onPressAction": "save",
              "style": {
                  "backgroundColor": "#22c55e"
              }
          }
      ]
  }
];
